import { CreateBrandLogoDTO, DeleteBrandLogoDTO } from './../../../base/models/models.swagger.generated';
import { catchError, finalize, tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { BrandLogoClient, FilterDTO, SortDirection } from 'src/app/base/models/models.swagger.generated';
import { ToastService } from 'src/app/base/services/toast.service';
import { ShowInactiveService } from 'src/app/base/shared/grid-base/show-inactive.service';
import { IAdaptorService } from 'src/app/base/shared/syncfusion/adaptor-service.interface';
import { IPagedItems } from 'src/app/base/shared/syncfusion/paged-items.interface';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { ErrorType } from 'src/app/core/routing/error-types';

@Injectable({
  providedIn: 'root'
})
export class BrandLogosService extends ShowInactiveService implements IAdaptorService{

  constructor(
    private brandLogoClient: BrandLogoClient,
    private toastService: ToastService,
    private spinnerService: SpinnerService
  ) {
    super();
  }

  getData(skip: number, take: number, filters: FilterDTO[], sortBy: string, sortDirection: SortDirection): Observable<IPagedItems> {
    return this.brandLogoClient.searchBrandLogos(skip, take, sortBy, sortDirection, false, filters)
      .pipe(
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        })
      );
  }

  addRecord(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }
  updateRecord(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }
  deleteRecord(id: number): Observable<any> {
    throw new Error('Method not implemented.');
  }

  public createBrandLogo(dto: CreateBrandLogoDTO) {
    this.spinnerService.show();
    return this.brandLogoClient.createBrandLogo(dto).pipe(
      tap(() => {
        this.toastService.showSuccess(
          'i18n.domain.assets.product-assets.edit-asset.messages.create.success-title',
          'i18n.domain.assets.product-assets.edit-asset.messages.create.success-message');
      }),
      finalize(() => {
        this.spinnerService.hide();
      }),
      catchError(err => {
        if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
          this.toastService.showError(
            'i18n.domain.assets.product-assets.edit-asset.messages.create.fail-title',
            'i18n.domain.assets.product-assets.edit-asset.messages.create.fail-message', null, ErrorType.serverError);
        }
        return throwError(() => err);
      })
    );
  }

  public deleteBrandLogo(dto: DeleteBrandLogoDTO): Observable<any> {
    return this.brandLogoClient.deleteBrandLogo(dto)
    .pipe(
      tap(() => {
        this.toastService.showSuccess(
          'i18n.domain.assets.product-assets.edit-asset.messages.delete.success-title',
          'i18n.domain.assets.product-assets.edit-asset.messages.delete.success-message');
      }),
      catchError((error: any) => {
        if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
          this.toastService.showError(
            'i18n.domain.assets.product-assets.edit-asset.messages.delete.fail-title',
            'i18n.domain.assets.product-assets.edit-asset.messages.delete.fail-message', null, ErrorType.serverError);
        }
        return throwError(() => error);
      })
    );
  }
}
